import './mission-tabs.scss';

const missionTabs = () => {
    const missionTabs = document.querySelectorAll('.mission-tabs-section .tabs [data-tab-target]')
    const missionTabContents = document.querySelectorAll('.mission-tabs-section .tab-content [data-tab-content]')
    const textImgBlock = document.querySelector('.mission-tab');
    const imgWrapperTabs = document.querySelectorAll('.text-img-wrapper .img-wrapper-tab');
    const dspWrapperTabs = document.querySelectorAll('.text-img-wrapper .dsp-wrapper-tab');

    if (missionTabs) {

        missionTabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const target = document.querySelector(tab.dataset.tabTarget)
                missionTabContents.forEach(tabContent => {
                })
                missionTabs.forEach(tab => {
                    tab.classList.remove('active')
                })
                tab.classList.add('active');

                imgWrapperTabs.forEach(imgTab => {
                    imgTab.classList.remove('active'); 
                });
                dspWrapperTabs.forEach(dspTab => {
                    dspTab.classList.remove('active'); 
                });

                if (target) {
                    target.classList.add('active')
                }

                if (tab.dataset.tabTarget === '#first-tab') {
                    imgWrapperTabs[0].classList.add('active');
                    dspWrapperTabs[0].classList.add('active');
                } else if (tab.dataset.tabTarget === '#second-tab') {
                    imgWrapperTabs[1].classList.add('active');
                    dspWrapperTabs[1].classList.add('active');
                }

                if (tab.dataset.tabTarget === '#second-tab') {
                    textImgBlock.classList.add('change-side');
                } else {
                    textImgBlock.classList.remove('change-side');
                }

            })
        });
    }
}
export default missionTabs;